export default {
  cancel: 'Cancel',
  logout: 'Yes, logout',
  deactivate: 'Deactivate',
  edit: 'Edit',
  confirm: 'Confirm',
  request_leave: 'Request leave',
  save: 'Save',
  add_route: 'Add new route',
  edit_route: 'Edit route',
  export: 'Export',
  import: 'Import',
  activate: 'Activate',
  btn_deactivate: 'Yes, deactivate',
  btn_activate: 'Yes, activate',
  open_requests: 'Open requests',
  all_leaves: 'All leaves',
  my_leave: 'My leave',
  reject: 'Reject',
  yes_confirm: 'Yes, confirm',
  yes_reject: 'Yes, reject',
  send: 'Send',
  approve: 'Approve',
  yes_delete: 'Yes, delete',
  new_work_log: 'New Work Log',
  end_journey: 'End journey',
  edit_journey: 'Worklog details ',
  delete_work_log: 'Delete work log',
  yes_delete_work_log: 'Yes, reject',
  send_reason: 'Send',
}
